export default __webpack_public_path__ + "static/segment-builder-a0a4b5f53a64c2ed02e0d521eda718c9.png";